export const buildAcceptanceBarSegments = (stats) => {
  if (!stats) return null;
  const a = Number(stats.acceptedCount) || 0;
  const p = Number(stats.pendingCount) || 0;
  const r = Number(stats.rejectedCount) || 0;
  const t = Number(stats.totalRequiringAcceptance) || 0;
  const sum = a + p + r;
  const denom = t > 0 ? t : sum;
  const remainder = t > 0 ? Math.max(0, t - sum) : 0;
  const hasAny = denom > 0 && (sum > 0 || remainder > 0);
  return { a, p, r, denom, remainder, hasAny };
};
